<template>
  <v-content>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      v-model="menu"
      transition="scale-transition"
      offset-y
      :nudge-right="40"
      min-width="290px"
      :return-value.sync="date"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          slot="activator"
          label="Data de Nascimento"
          :value="computedDateFormattedMomentjs"
          solo
          flat
          readonly
          :rules="rules"
          v-on="on"
          required
          background-color="#F7F7F7"
        ></v-text-field>
      </template>
      <v-date-picker ref="picker" v-model="date" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn text color="primary" @click="emitDate(date)">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </v-content>
</template>

<script>
import moment from 'moment-timezone';

export default {
  data() {
    return {
      date: '',
      menu: false,
      rules: [v => !!v || 'Esse campo é obrigatório'],
    };
  },
  props: {
    label: String,
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format('DD/MM/YYYY') : '';
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },
  methods: {
    emitDate(v) {
      this.$emit('date', v);
      this.$refs.menu.save(v);
    },
  },
};
</script>
